import * as Yt from "react";
import Wr, { createContext as $s, useContext as _s, useMemo as Yr, useState as qr, useEffect as Hr } from "react";
var $e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function et(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var We = { exports: {} }, ie = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function Ts() {
  if (qt)
    return ie;
  qt = 1;
  var e = Wr, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, o, c) {
    var f, p = {}, h = null, $ = null;
    c !== void 0 && (h = "" + c), o.key !== void 0 && (h = "" + o.key), o.ref !== void 0 && ($ = o.ref);
    for (f in o)
      n.call(o, f) && !a.hasOwnProperty(f) && (p[f] = o[f]);
    if (u && u.defaultProps)
      for (f in o = u.defaultProps, o)
        p[f] === void 0 && (p[f] = o[f]);
    return { $$typeof: t, type: u, key: h, ref: $, props: p, _owner: s.current };
  }
  return ie.Fragment = r, ie.jsx = l, ie.jsxs = l, ie;
}
var oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ht;
function ms() {
  return Ht || (Ht = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Wr, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), $ = Symbol.for("react.offscreen"), y = Symbol.iterator, N = "@@iterator";
    function E(i) {
      if (i === null || typeof i != "object")
        return null;
      var d = y && i[y] || i[N];
      return typeof d == "function" ? d : null;
    }
    var P = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(i) {
      {
        for (var d = arguments.length, g = new Array(d > 1 ? d - 1 : 0), b = 1; b < d; b++)
          g[b - 1] = arguments[b];
        pe("error", i, g);
      }
    }
    function pe(i, d, g) {
      {
        var b = P.ReactDebugCurrentFrame, m = b.getStackAddendum();
        m !== "" && (d += "%s", g = g.concat([m]));
        var A = g.map(function(T) {
          return String(T);
        });
        A.unshift("Warning: " + d), Function.prototype.apply.call(console[i], console, A);
      }
    }
    var q = !1, H = !1, Kn = !1, Xn = !1, Wn = !1, mt;
    mt = Symbol.for("react.module.reference");
    function Yn(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === n || i === a || Wn || i === s || i === c || i === f || Xn || i === $ || q || H || Kn || typeof i == "object" && i !== null && (i.$$typeof === h || i.$$typeof === p || i.$$typeof === l || i.$$typeof === u || i.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === mt || i.getModuleId !== void 0));
    }
    function qn(i, d, g) {
      var b = i.displayName;
      if (b)
        return b;
      var m = d.displayName || d.name || "";
      return m !== "" ? g + "(" + m + ")" : g;
    }
    function Et(i) {
      return i.displayName || "Context";
    }
    function M(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case u:
            var d = i;
            return Et(d) + ".Consumer";
          case l:
            var g = i;
            return Et(g._context) + ".Provider";
          case o:
            return qn(i, i.render, "ForwardRef");
          case p:
            var b = i.displayName || null;
            return b !== null ? b : M(i.type) || "Memo";
          case h: {
            var m = i, A = m._payload, T = m._init;
            try {
              return M(T(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, se = 0, At, Ot, Ct, wt, Nt, Pt, St;
    function xt() {
    }
    xt.__reactDisabledLog = !0;
    function Hn() {
      {
        if (se === 0) {
          At = console.log, Ot = console.info, Ct = console.warn, wt = console.error, Nt = console.group, Pt = console.groupCollapsed, St = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: xt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        se++;
      }
    }
    function zn() {
      {
        if (se--, se === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, i, {
              value: At
            }),
            info: K({}, i, {
              value: Ot
            }),
            warn: K({}, i, {
              value: Ct
            }),
            error: K({}, i, {
              value: wt
            }),
            group: K({}, i, {
              value: Nt
            }),
            groupCollapsed: K({}, i, {
              value: Pt
            }),
            groupEnd: K({}, i, {
              value: St
            })
          });
        }
        se < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = P.ReactCurrentDispatcher, Fe;
    function ge(i, d, g) {
      {
        if (Fe === void 0)
          try {
            throw Error();
          } catch (m) {
            var b = m.stack.trim().match(/\n( *(at )?)/);
            Fe = b && b[1] || "";
          }
        return `
` + Fe + i;
      }
    }
    var Le = !1, he;
    {
      var Jn = typeof WeakMap == "function" ? WeakMap : Map;
      he = new Jn();
    }
    function jt(i, d) {
      if (!i || Le)
        return "";
      {
        var g = he.get(i);
        if (g !== void 0)
          return g;
      }
      var b;
      Le = !0;
      var m = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = Re.current, Re.current = null, Hn();
      try {
        if (d) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (B) {
              b = B;
            }
            Reflect.construct(i, [], T);
          } else {
            try {
              T.call();
            } catch (B) {
              b = B;
            }
            i.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (B) {
            b = B;
          }
          i();
        }
      } catch (B) {
        if (B && b && typeof B.stack == "string") {
          for (var _ = B.stack.split(`
`), I = b.stack.split(`
`), S = _.length - 1, j = I.length - 1; S >= 1 && j >= 0 && _[S] !== I[j]; )
            j--;
          for (; S >= 1 && j >= 0; S--, j--)
            if (_[S] !== I[j]) {
              if (S !== 1 || j !== 1)
                do
                  if (S--, j--, j < 0 || _[S] !== I[j]) {
                    var F = `
` + _[S].replace(" at new ", " at ");
                    return i.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", i.displayName)), typeof i == "function" && he.set(i, F), F;
                  }
                while (S >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Re.current = A, zn(), Error.prepareStackTrace = m;
      }
      var J = i ? i.displayName || i.name : "", Wt = J ? ge(J) : "";
      return typeof i == "function" && he.set(i, Wt), Wt;
    }
    function Zn(i, d, g) {
      return jt(i, !1);
    }
    function Qn(i) {
      var d = i.prototype;
      return !!(d && d.isReactComponent);
    }
    function ve(i, d, g) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return jt(i, Qn(i));
      if (typeof i == "string")
        return ge(i);
      switch (i) {
        case c:
          return ge("Suspense");
        case f:
          return ge("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case o:
            return Zn(i.render);
          case p:
            return ve(i.type, d, g);
          case h: {
            var b = i, m = b._payload, A = b._init;
            try {
              return ve(A(m), d, g);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, It = {}, Rt = P.ReactDebugCurrentFrame;
    function ye(i) {
      if (i) {
        var d = i._owner, g = ve(i.type, i._source, d ? d.type : null);
        Rt.setExtraStackFrame(g);
      } else
        Rt.setExtraStackFrame(null);
    }
    function Dn(i, d, g, b, m) {
      {
        var A = Function.call.bind(be);
        for (var T in i)
          if (A(i, T)) {
            var _ = void 0;
            try {
              if (typeof i[T] != "function") {
                var I = Error((b || "React class") + ": " + g + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw I.name = "Invariant Violation", I;
              }
              _ = i[T](d, T, b, g, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (S) {
              _ = S;
            }
            _ && !(_ instanceof Error) && (ye(m), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", g, T, typeof _), ye(null)), _ instanceof Error && !(_.message in It) && (It[_.message] = !0, ye(m), w("Failed %s type: %s", g, _.message), ye(null));
          }
      }
    }
    var es = Array.isArray;
    function Me(i) {
      return es(i);
    }
    function ts(i) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, g = d && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return g;
      }
    }
    function rs(i) {
      try {
        return Ft(i), !1;
      } catch {
        return !0;
      }
    }
    function Ft(i) {
      return "" + i;
    }
    function Lt(i) {
      if (rs(i))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ts(i)), Ft(i);
    }
    var ae = P.ReactCurrentOwner, ns = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Mt, Bt, Be;
    Be = {};
    function ss(i) {
      if (be.call(i, "ref")) {
        var d = Object.getOwnPropertyDescriptor(i, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return i.ref !== void 0;
    }
    function as(i) {
      if (be.call(i, "key")) {
        var d = Object.getOwnPropertyDescriptor(i, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return i.key !== void 0;
    }
    function is(i, d) {
      if (typeof i.ref == "string" && ae.current && d && ae.current.stateNode !== d) {
        var g = M(ae.current.type);
        Be[g] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', M(ae.current.type), i.ref), Be[g] = !0);
      }
    }
    function os(i, d) {
      {
        var g = function() {
          Mt || (Mt = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        g.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: g,
          configurable: !0
        });
      }
    }
    function us(i, d) {
      {
        var g = function() {
          Bt || (Bt = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        g.isReactWarning = !0, Object.defineProperty(i, "ref", {
          get: g,
          configurable: !0
        });
      }
    }
    var ls = function(i, d, g, b, m, A, T) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: i,
        key: d,
        ref: g,
        props: T,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: b
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function cs(i, d, g, b, m) {
      {
        var A, T = {}, _ = null, I = null;
        g !== void 0 && (Lt(g), _ = "" + g), as(d) && (Lt(d.key), _ = "" + d.key), ss(d) && (I = d.ref, is(d, m));
        for (A in d)
          be.call(d, A) && !ns.hasOwnProperty(A) && (T[A] = d[A]);
        if (i && i.defaultProps) {
          var S = i.defaultProps;
          for (A in S)
            T[A] === void 0 && (T[A] = S[A]);
        }
        if (_ || I) {
          var j = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
          _ && os(T, j), I && us(T, j);
        }
        return ls(i, _, I, m, b, ae.current, T);
      }
    }
    var Ge = P.ReactCurrentOwner, Gt = P.ReactDebugCurrentFrame;
    function z(i) {
      if (i) {
        var d = i._owner, g = ve(i.type, i._source, d ? d.type : null);
        Gt.setExtraStackFrame(g);
      } else
        Gt.setExtraStackFrame(null);
    }
    var Ve;
    Ve = !1;
    function Ue(i) {
      return typeof i == "object" && i !== null && i.$$typeof === t;
    }
    function Vt() {
      {
        if (Ge.current) {
          var i = M(Ge.current.type);
          if (i)
            return `

Check the render method of \`` + i + "`.";
        }
        return "";
      }
    }
    function fs(i) {
      {
        if (i !== void 0) {
          var d = i.fileName.replace(/^.*[\\\/]/, ""), g = i.lineNumber;
          return `

Check your code at ` + d + ":" + g + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function ds(i) {
      {
        var d = Vt();
        if (!d) {
          var g = typeof i == "string" ? i : i.displayName || i.name;
          g && (d = `

Check the top-level render call using <` + g + ">.");
        }
        return d;
      }
    }
    function kt(i, d) {
      {
        if (!i._store || i._store.validated || i.key != null)
          return;
        i._store.validated = !0;
        var g = ds(d);
        if (Ut[g])
          return;
        Ut[g] = !0;
        var b = "";
        i && i._owner && i._owner !== Ge.current && (b = " It was passed a child from " + M(i._owner.type) + "."), z(i), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', g, b), z(null);
      }
    }
    function Kt(i, d) {
      {
        if (typeof i != "object")
          return;
        if (Me(i))
          for (var g = 0; g < i.length; g++) {
            var b = i[g];
            Ue(b) && kt(b, d);
          }
        else if (Ue(i))
          i._store && (i._store.validated = !0);
        else if (i) {
          var m = E(i);
          if (typeof m == "function" && m !== i.entries)
            for (var A = m.call(i), T; !(T = A.next()).done; )
              Ue(T.value) && kt(T.value, d);
        }
      }
    }
    function ps(i) {
      {
        var d = i.type;
        if (d == null || typeof d == "string")
          return;
        var g;
        if (typeof d == "function")
          g = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === p))
          g = d.propTypes;
        else
          return;
        if (g) {
          var b = M(d);
          Dn(g, i.props, "prop", b, i);
        } else if (d.PropTypes !== void 0 && !Ve) {
          Ve = !0;
          var m = M(d);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function gs(i) {
      {
        for (var d = Object.keys(i.props), g = 0; g < d.length; g++) {
          var b = d[g];
          if (b !== "children" && b !== "key") {
            z(i), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", b), z(null);
            break;
          }
        }
        i.ref !== null && (z(i), w("Invalid attribute `ref` supplied to `React.Fragment`."), z(null));
      }
    }
    function Xt(i, d, g, b, m, A) {
      {
        var T = Yn(i);
        if (!T) {
          var _ = "";
          (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var I = fs(m);
          I ? _ += I : _ += Vt();
          var S;
          i === null ? S = "null" : Me(i) ? S = "array" : i !== void 0 && i.$$typeof === t ? (S = "<" + (M(i.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : S = typeof i, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", S, _);
        }
        var j = cs(i, d, g, m, A);
        if (j == null)
          return j;
        if (T) {
          var F = d.children;
          if (F !== void 0)
            if (b)
              if (Me(F)) {
                for (var J = 0; J < F.length; J++)
                  Kt(F[J], i);
                Object.freeze && Object.freeze(F);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Kt(F, i);
        }
        return i === n ? gs(j) : ps(j), j;
      }
    }
    function hs(i, d, g) {
      return Xt(i, d, g, !0);
    }
    function vs(i, d, g) {
      return Xt(i, d, g, !1);
    }
    var bs = vs, ys = hs;
    oe.Fragment = n, oe.jsx = bs, oe.jsxs = ys;
  }()), oe;
}
process.env.NODE_ENV === "production" ? We.exports = Ts() : We.exports = ms();
var v = We.exports;
const zt = ":@", Ee = "#text", tt = "#comment", rt = "#cdata", zr = "DECLARATION_TAG", Es = "TAG", Ye = {
  tagColor: "#d43900",
  textColor: "#333",
  attributeKeyColor: "#2a7ab0",
  attributeValueColor: "#008000",
  separatorColor: "#333",
  commentColor: "#aaa",
  cdataColor: "#1d781d",
  fontFamily: "monospace"
}, As = {
  theme: Ye,
  collapsible: !1,
  indentSize: 2
}, Jr = $s(As), G = () => _s(Jr);
var nt = {}, Ne = {};
(function(e) {
  const t = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", r = t + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", n = "[" + t + "][" + r + "]*", s = new RegExp("^" + n + "$"), a = function(u, o) {
    const c = [];
    let f = o.exec(u);
    for (; f; ) {
      const p = [];
      p.startIndex = o.lastIndex - f[0].length;
      const h = f.length;
      for (let $ = 0; $ < h; $++)
        p.push(f[$]);
      c.push(p), f = o.exec(u);
    }
    return c;
  }, l = function(u) {
    const o = s.exec(u);
    return !(o === null || typeof o > "u");
  };
  e.isExist = function(u) {
    return typeof u < "u";
  }, e.isEmptyObject = function(u) {
    return Object.keys(u).length === 0;
  }, e.merge = function(u, o, c) {
    if (o) {
      const f = Object.keys(o), p = f.length;
      for (let h = 0; h < p; h++)
        c === "strict" ? u[f[h]] = [o[f[h]]] : u[f[h]] = o[f[h]];
    }
  }, e.getValue = function(u) {
    return e.isExist(u) ? u : "";
  }, e.isName = l, e.getAllMatches = a, e.nameRegexp = n;
})(Ne);
const st = Ne, Os = {
  allowBooleanAttributes: !1,
  //A tag can have attributes without any value
  unpairedTags: []
};
nt.validate = function(e, t) {
  t = Object.assign({}, Os, t);
  const r = [];
  let n = !1, s = !1;
  e[0] === "\uFEFF" && (e = e.substr(1));
  for (let a = 0; a < e.length; a++)
    if (e[a] === "<" && e[a + 1] === "?") {
      if (a += 2, a = Zt(e, a), a.err)
        return a;
    } else if (e[a] === "<") {
      let l = a;
      if (a++, e[a] === "!") {
        a = Qt(e, a);
        continue;
      } else {
        let u = !1;
        e[a] === "/" && (u = !0, a++);
        let o = "";
        for (; a < e.length && e[a] !== ">" && e[a] !== " " && e[a] !== "	" && e[a] !== `
` && e[a] !== "\r"; a++)
          o += e[a];
        if (o = o.trim(), o[o.length - 1] === "/" && (o = o.substring(0, o.length - 1), a--), !Is(o)) {
          let p;
          return o.trim().length === 0 ? p = "Invalid space after '<'." : p = "Tag '" + o + "' is an invalid name.", x("InvalidTag", p, R(e, a));
        }
        const c = Ns(e, a);
        if (c === !1)
          return x("InvalidAttr", "Attributes for '" + o + "' have open quote.", R(e, a));
        let f = c.value;
        if (a = c.index, f[f.length - 1] === "/") {
          const p = a - f.length;
          f = f.substring(0, f.length - 1);
          const h = Dt(f, t);
          if (h === !0)
            n = !0;
          else
            return x(h.err.code, h.err.msg, R(e, p + h.err.line));
        } else if (u)
          if (c.tagClosed) {
            if (f.trim().length > 0)
              return x("InvalidTag", "Closing tag '" + o + "' can't have attributes or invalid starting.", R(e, l));
            if (r.length === 0)
              return x("InvalidTag", "Closing tag '" + o + "' has not been opened.", R(e, l));
            {
              const p = r.pop();
              if (o !== p.tagName) {
                let h = R(e, p.tagStartPos);
                return x(
                  "InvalidTag",
                  "Expected closing tag '" + p.tagName + "' (opened in line " + h.line + ", col " + h.col + ") instead of closing tag '" + o + "'.",
                  R(e, l)
                );
              }
              r.length == 0 && (s = !0);
            }
          } else
            return x("InvalidTag", "Closing tag '" + o + "' doesn't have proper closing.", R(e, a));
        else {
          const p = Dt(f, t);
          if (p !== !0)
            return x(p.err.code, p.err.msg, R(e, a - f.length + p.err.line));
          if (s === !0)
            return x("InvalidXml", "Multiple possible root nodes found.", R(e, a));
          t.unpairedTags.indexOf(o) !== -1 || r.push({ tagName: o, tagStartPos: l }), n = !0;
        }
        for (a++; a < e.length; a++)
          if (e[a] === "<")
            if (e[a + 1] === "!") {
              a++, a = Qt(e, a);
              continue;
            } else if (e[a + 1] === "?") {
              if (a = Zt(e, ++a), a.err)
                return a;
            } else
              break;
          else if (e[a] === "&") {
            const p = xs(e, a);
            if (p == -1)
              return x("InvalidChar", "char '&' is not expected.", R(e, a));
            a = p;
          } else if (s === !0 && !Jt(e[a]))
            return x("InvalidXml", "Extra text at the end", R(e, a));
        e[a] === "<" && a--;
      }
    } else {
      if (Jt(e[a]))
        continue;
      return x("InvalidChar", "char '" + e[a] + "' is not expected.", R(e, a));
    }
  if (n) {
    if (r.length == 1)
      return x("InvalidTag", "Unclosed tag '" + r[0].tagName + "'.", R(e, r[0].tagStartPos));
    if (r.length > 0)
      return x("InvalidXml", "Invalid '" + JSON.stringify(r.map((a) => a.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else
    return x("InvalidXml", "Start tag expected.", 1);
  return !0;
};
function Jt(e) {
  return e === " " || e === "	" || e === `
` || e === "\r";
}
function Zt(e, t) {
  const r = t;
  for (; t < e.length; t++)
    if (e[t] == "?" || e[t] == " ") {
      const n = e.substr(r, t - r);
      if (t > 5 && n === "xml")
        return x("InvalidXml", "XML declaration allowed only at the start of the document.", R(e, t));
      if (e[t] == "?" && e[t + 1] == ">") {
        t++;
        break;
      } else
        continue;
    }
  return t;
}
function Qt(e, t) {
  if (e.length > t + 5 && e[t + 1] === "-" && e[t + 2] === "-") {
    for (t += 3; t < e.length; t++)
      if (e[t] === "-" && e[t + 1] === "-" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  } else if (e.length > t + 8 && e[t + 1] === "D" && e[t + 2] === "O" && e[t + 3] === "C" && e[t + 4] === "T" && e[t + 5] === "Y" && e[t + 6] === "P" && e[t + 7] === "E") {
    let r = 1;
    for (t += 8; t < e.length; t++)
      if (e[t] === "<")
        r++;
      else if (e[t] === ">" && (r--, r === 0))
        break;
  } else if (e.length > t + 9 && e[t + 1] === "[" && e[t + 2] === "C" && e[t + 3] === "D" && e[t + 4] === "A" && e[t + 5] === "T" && e[t + 6] === "A" && e[t + 7] === "[") {
    for (t += 8; t < e.length; t++)
      if (e[t] === "]" && e[t + 1] === "]" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  }
  return t;
}
const Cs = '"', ws = "'";
function Ns(e, t) {
  let r = "", n = "", s = !1;
  for (; t < e.length; t++) {
    if (e[t] === Cs || e[t] === ws)
      n === "" ? n = e[t] : n !== e[t] || (n = "");
    else if (e[t] === ">" && n === "") {
      s = !0;
      break;
    }
    r += e[t];
  }
  return n !== "" ? !1 : {
    value: r,
    index: t,
    tagClosed: s
  };
}
const Ps = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function Dt(e, t) {
  const r = st.getAllMatches(e, Ps), n = {};
  for (let s = 0; s < r.length; s++) {
    if (r[s][1].length === 0)
      return x("InvalidAttr", "Attribute '" + r[s][2] + "' has no space in starting.", ue(r[s]));
    if (r[s][3] !== void 0 && r[s][4] === void 0)
      return x("InvalidAttr", "Attribute '" + r[s][2] + "' is without value.", ue(r[s]));
    if (r[s][3] === void 0 && !t.allowBooleanAttributes)
      return x("InvalidAttr", "boolean attribute '" + r[s][2] + "' is not allowed.", ue(r[s]));
    const a = r[s][2];
    if (!js(a))
      return x("InvalidAttr", "Attribute '" + a + "' is an invalid name.", ue(r[s]));
    if (!n.hasOwnProperty(a))
      n[a] = 1;
    else
      return x("InvalidAttr", "Attribute '" + a + "' is repeated.", ue(r[s]));
  }
  return !0;
}
function Ss(e, t) {
  let r = /\d/;
  for (e[t] === "x" && (t++, r = /[\da-fA-F]/); t < e.length; t++) {
    if (e[t] === ";")
      return t;
    if (!e[t].match(r))
      break;
  }
  return -1;
}
function xs(e, t) {
  if (t++, e[t] === ";")
    return -1;
  if (e[t] === "#")
    return t++, Ss(e, t);
  let r = 0;
  for (; t < e.length; t++, r++)
    if (!(e[t].match(/\w/) && r < 20)) {
      if (e[t] === ";")
        break;
      return -1;
    }
  return t;
}
function x(e, t, r) {
  return {
    err: {
      code: e,
      msg: t,
      line: r.line || r,
      col: r.col
    }
  };
}
function js(e) {
  return st.isName(e);
}
function Is(e) {
  return st.isName(e);
}
function R(e, t) {
  const r = e.substring(0, t).split(/\r?\n/);
  return {
    line: r.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: r[r.length - 1].length + 1
  };
}
function ue(e) {
  return e.startIndex + e[1].length;
}
var at = {};
const Zr = {
  preserveOrder: !1,
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  removeNSPrefix: !1,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: !1,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: !0,
  parseAttributeValue: !1,
  trimValues: !0,
  //Trim string values of tag and attributes
  cdataPropName: !1,
  numberParseOptions: {
    hex: !0,
    leadingZeros: !0,
    eNotation: !0
  },
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: !1,
  isArray: () => !1,
  commentPropName: !1,
  unpairedTags: [],
  processEntities: !0,
  htmlEntities: !1,
  ignoreDeclaration: !1,
  ignorePiTags: !1,
  transformTagName: !1,
  transformAttributeName: !1,
  updateTag: function(e, t, r) {
    return e;
  }
  // skipEmptyListItem: false
}, Rs = function(e) {
  return Object.assign({}, Zr, e);
};
at.buildOptions = Rs;
at.defaultOptions = Zr;
class Fs {
  constructor(t) {
    this.tagname = t, this.child = [], this[":@"] = {};
  }
  add(t, r) {
    t === "__proto__" && (t = "#__proto__"), this.child.push({ [t]: r });
  }
  addChild(t) {
    t.tagname === "__proto__" && (t.tagname = "#__proto__"), t[":@"] && Object.keys(t[":@"]).length > 0 ? this.child.push({ [t.tagname]: t.child, [":@"]: t[":@"] }) : this.child.push({ [t.tagname]: t.child });
  }
}
var Ls = Fs;
const Ms = Ne;
function Bs(e, t) {
  const r = {};
  if (e[t + 3] === "O" && e[t + 4] === "C" && e[t + 5] === "T" && e[t + 6] === "Y" && e[t + 7] === "P" && e[t + 8] === "E") {
    t = t + 9;
    let n = 1, s = !1, a = !1, l = "";
    for (; t < e.length; t++)
      if (e[t] === "<" && !a) {
        if (s && Us(e, t))
          t += 7, [entityName, val, t] = Gs(e, t + 1), val.indexOf("&") === -1 && (r[Ws(entityName)] = {
            regx: RegExp(`&${entityName};`, "g"),
            val
          });
        else if (s && ks(e, t))
          t += 8;
        else if (s && Ks(e, t))
          t += 8;
        else if (s && Xs(e, t))
          t += 9;
        else if (Vs)
          a = !0;
        else
          throw new Error("Invalid DOCTYPE");
        n++, l = "";
      } else if (e[t] === ">") {
        if (a ? e[t - 1] === "-" && e[t - 2] === "-" && (a = !1, n--) : n--, n === 0)
          break;
      } else
        e[t] === "[" ? s = !0 : l += e[t];
    if (n !== 0)
      throw new Error("Unclosed DOCTYPE");
  } else
    throw new Error("Invalid Tag instead of DOCTYPE");
  return { entities: r, i: t };
}
function Gs(e, t) {
  let r = "";
  for (; t < e.length && e[t] !== "'" && e[t] !== '"'; t++)
    r += e[t];
  if (r = r.trim(), r.indexOf(" ") !== -1)
    throw new Error("External entites are not supported");
  const n = e[t++];
  let s = "";
  for (; t < e.length && e[t] !== n; t++)
    s += e[t];
  return [r, s, t];
}
function Vs(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "-" && e[t + 3] === "-";
}
function Us(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "N" && e[t + 4] === "T" && e[t + 5] === "I" && e[t + 6] === "T" && e[t + 7] === "Y";
}
function ks(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "L" && e[t + 4] === "E" && e[t + 5] === "M" && e[t + 6] === "E" && e[t + 7] === "N" && e[t + 8] === "T";
}
function Ks(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "A" && e[t + 3] === "T" && e[t + 4] === "T" && e[t + 5] === "L" && e[t + 6] === "I" && e[t + 7] === "S" && e[t + 8] === "T";
}
function Xs(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "N" && e[t + 3] === "O" && e[t + 4] === "T" && e[t + 5] === "A" && e[t + 6] === "T" && e[t + 7] === "I" && e[t + 8] === "O" && e[t + 9] === "N";
}
function Ws(e) {
  if (Ms.isName(e))
    return e;
  throw new Error(`Invalid entity name ${e}`);
}
var Ys = Bs;
const qs = /^[-+]?0x[a-fA-F0-9]+$/, Hs = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
!Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt);
!Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const zs = {
  hex: !0,
  leadingZeros: !0,
  decimalPoint: ".",
  eNotation: !0
  //skipLike: /regex/
};
function Js(e, t = {}) {
  if (t = Object.assign({}, zs, t), !e || typeof e != "string")
    return e;
  let r = e.trim();
  if (t.skipLike !== void 0 && t.skipLike.test(r))
    return e;
  if (t.hex && qs.test(r))
    return Number.parseInt(r, 16);
  {
    const n = Hs.exec(r);
    if (n) {
      const s = n[1], a = n[2];
      let l = Zs(n[3]);
      const u = n[4] || n[6];
      if (!t.leadingZeros && a.length > 0 && s && r[2] !== ".")
        return e;
      if (!t.leadingZeros && a.length > 0 && !s && r[1] !== ".")
        return e;
      {
        const o = Number(r), c = "" + o;
        return c.search(/[eE]/) !== -1 || u ? t.eNotation ? o : e : r.indexOf(".") !== -1 ? c === "0" && l === "" || c === l || s && c === "-" + l ? o : e : a ? l === c || s + l === c ? o : e : r === c || r === s + c ? o : e;
      }
    } else
      return e;
  }
}
function Zs(e) {
  return e && e.indexOf(".") !== -1 && (e = e.replace(/0+$/, ""), e === "." ? e = "0" : e[0] === "." ? e = "0" + e : e[e.length - 1] === "." && (e = e.substr(0, e.length - 1))), e;
}
var Qs = Js;
function Ds(e) {
  return typeof e == "function" ? e : Array.isArray(e) ? (t) => {
    for (const r of e)
      if (typeof r == "string" && t === r || r instanceof RegExp && r.test(t))
        return !0;
  } : () => !1;
}
var Qr = Ds;
const Dr = Ne, le = Ls, ea = Ys, ta = Qs, ra = Qr;
let na = class {
  constructor(t) {
    this.options = t, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = {
      apos: { regex: /&(apos|#39|#x27);/g, val: "'" },
      gt: { regex: /&(gt|#62|#x3E);/g, val: ">" },
      lt: { regex: /&(lt|#60|#x3C);/g, val: "<" },
      quot: { regex: /&(quot|#34|#x22);/g, val: '"' }
    }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = {
      space: { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      cent: { regex: /&(cent|#162);/g, val: "¢" },
      pound: { regex: /&(pound|#163);/g, val: "£" },
      yen: { regex: /&(yen|#165);/g, val: "¥" },
      euro: { regex: /&(euro|#8364);/g, val: "€" },
      copyright: { regex: /&(copy|#169);/g, val: "©" },
      reg: { regex: /&(reg|#174);/g, val: "®" },
      inr: { regex: /&(inr|#8377);/g, val: "₹" },
      num_dec: { regex: /&#([0-9]{1,7});/g, val: (r, n) => String.fromCharCode(Number.parseInt(n, 10)) },
      num_hex: { regex: /&#x([0-9a-fA-F]{1,6});/g, val: (r, n) => String.fromCharCode(Number.parseInt(n, 16)) }
    }, this.addExternalEntities = sa, this.parseXml = la, this.parseTextData = aa, this.resolveNameSpace = ia, this.buildAttributesMap = ua, this.isItStopNode = pa, this.replaceEntitiesValue = fa, this.readStopNodeData = ha, this.saveTextToParentTag = da, this.addChild = ca, this.ignoreAttributesFn = ra(this.options.ignoreAttributes);
  }
};
function sa(e) {
  const t = Object.keys(e);
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    this.lastEntities[n] = {
      regex: new RegExp("&" + n + ";", "g"),
      val: e[n]
    };
  }
}
function aa(e, t, r, n, s, a, l) {
  if (e !== void 0 && (this.options.trimValues && !n && (e = e.trim()), e.length > 0)) {
    l || (e = this.replaceEntitiesValue(e));
    const u = this.options.tagValueProcessor(t, e, r, s, a);
    return u == null ? e : typeof u != typeof e || u !== e ? u : this.options.trimValues ? He(e, this.options.parseTagValue, this.options.numberParseOptions) : e.trim() === e ? He(e, this.options.parseTagValue, this.options.numberParseOptions) : e;
  }
}
function ia(e) {
  if (this.options.removeNSPrefix) {
    const t = e.split(":"), r = e.charAt(0) === "/" ? "/" : "";
    if (t[0] === "xmlns")
      return "";
    t.length === 2 && (e = r + t[1]);
  }
  return e;
}
const oa = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
function ua(e, t, r) {
  if (this.options.ignoreAttributes !== !0 && typeof e == "string") {
    const n = Dr.getAllMatches(e, oa), s = n.length, a = {};
    for (let l = 0; l < s; l++) {
      const u = this.resolveNameSpace(n[l][1]);
      if (this.ignoreAttributesFn(u, t))
        continue;
      let o = n[l][4], c = this.options.attributeNamePrefix + u;
      if (u.length)
        if (this.options.transformAttributeName && (c = this.options.transformAttributeName(c)), c === "__proto__" && (c = "#__proto__"), o !== void 0) {
          this.options.trimValues && (o = o.trim()), o = this.replaceEntitiesValue(o);
          const f = this.options.attributeValueProcessor(u, o, t);
          f == null ? a[c] = o : typeof f != typeof o || f !== o ? a[c] = f : a[c] = He(
            o,
            this.options.parseAttributeValue,
            this.options.numberParseOptions
          );
        } else
          this.options.allowBooleanAttributes && (a[c] = !0);
    }
    if (!Object.keys(a).length)
      return;
    if (this.options.attributesGroupName) {
      const l = {};
      return l[this.options.attributesGroupName] = a, l;
    }
    return a;
  }
}
const la = function(e) {
  e = e.replace(/\r\n?/g, `
`);
  const t = new le("!xml");
  let r = t, n = "", s = "";
  for (let a = 0; a < e.length; a++)
    if (e[a] === "<")
      if (e[a + 1] === "/") {
        const u = W(e, ">", a, "Closing Tag is not closed.");
        let o = e.substring(a + 2, u).trim();
        if (this.options.removeNSPrefix) {
          const p = o.indexOf(":");
          p !== -1 && (o = o.substr(p + 1));
        }
        this.options.transformTagName && (o = this.options.transformTagName(o)), r && (n = this.saveTextToParentTag(n, r, s));
        const c = s.substring(s.lastIndexOf(".") + 1);
        if (o && this.options.unpairedTags.indexOf(o) !== -1)
          throw new Error(`Unpaired tag can not be used as closing tag: </${o}>`);
        let f = 0;
        c && this.options.unpairedTags.indexOf(c) !== -1 ? (f = s.lastIndexOf(".", s.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : f = s.lastIndexOf("."), s = s.substring(0, f), r = this.tagsNodeStack.pop(), n = "", a = u;
      } else if (e[a + 1] === "?") {
        let u = qe(e, a, !1, "?>");
        if (!u)
          throw new Error("Pi Tag is not closed.");
        if (n = this.saveTextToParentTag(n, r, s), !(this.options.ignoreDeclaration && u.tagName === "?xml" || this.options.ignorePiTags)) {
          const o = new le(u.tagName);
          o.add(this.options.textNodeName, ""), u.tagName !== u.tagExp && u.attrExpPresent && (o[":@"] = this.buildAttributesMap(u.tagExp, s, u.tagName)), this.addChild(r, o, s);
        }
        a = u.closeIndex + 1;
      } else if (e.substr(a + 1, 3) === "!--") {
        const u = W(e, "-->", a + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          const o = e.substring(a + 4, u - 2);
          n = this.saveTextToParentTag(n, r, s), r.add(this.options.commentPropName, [{ [this.options.textNodeName]: o }]);
        }
        a = u;
      } else if (e.substr(a + 1, 2) === "!D") {
        const u = ea(e, a);
        this.docTypeEntities = u.entities, a = u.i;
      } else if (e.substr(a + 1, 2) === "![") {
        const u = W(e, "]]>", a, "CDATA is not closed.") - 2, o = e.substring(a + 9, u);
        n = this.saveTextToParentTag(n, r, s);
        let c = this.parseTextData(o, r.tagname, s, !0, !1, !0, !0);
        c == null && (c = ""), this.options.cdataPropName ? r.add(this.options.cdataPropName, [{ [this.options.textNodeName]: o }]) : r.add(this.options.textNodeName, c), a = u + 2;
      } else {
        let u = qe(e, a, this.options.removeNSPrefix), o = u.tagName;
        const c = u.rawTagName;
        let f = u.tagExp, p = u.attrExpPresent, h = u.closeIndex;
        this.options.transformTagName && (o = this.options.transformTagName(o)), r && n && r.tagname !== "!xml" && (n = this.saveTextToParentTag(n, r, s, !1));
        const $ = r;
        if ($ && this.options.unpairedTags.indexOf($.tagname) !== -1 && (r = this.tagsNodeStack.pop(), s = s.substring(0, s.lastIndexOf("."))), o !== t.tagname && (s += s ? "." + o : o), this.isItStopNode(this.options.stopNodes, s, o)) {
          let y = "";
          if (f.length > 0 && f.lastIndexOf("/") === f.length - 1)
            o[o.length - 1] === "/" ? (o = o.substr(0, o.length - 1), s = s.substr(0, s.length - 1), f = o) : f = f.substr(0, f.length - 1), a = u.closeIndex;
          else if (this.options.unpairedTags.indexOf(o) !== -1)
            a = u.closeIndex;
          else {
            const E = this.readStopNodeData(e, c, h + 1);
            if (!E)
              throw new Error(`Unexpected end of ${c}`);
            a = E.i, y = E.tagContent;
          }
          const N = new le(o);
          o !== f && p && (N[":@"] = this.buildAttributesMap(f, s, o)), y && (y = this.parseTextData(y, o, s, !0, p, !0, !0)), s = s.substr(0, s.lastIndexOf(".")), N.add(this.options.textNodeName, y), this.addChild(r, N, s);
        } else {
          if (f.length > 0 && f.lastIndexOf("/") === f.length - 1) {
            o[o.length - 1] === "/" ? (o = o.substr(0, o.length - 1), s = s.substr(0, s.length - 1), f = o) : f = f.substr(0, f.length - 1), this.options.transformTagName && (o = this.options.transformTagName(o));
            const y = new le(o);
            o !== f && p && (y[":@"] = this.buildAttributesMap(f, s, o)), this.addChild(r, y, s), s = s.substr(0, s.lastIndexOf("."));
          } else {
            const y = new le(o);
            this.tagsNodeStack.push(r), o !== f && p && (y[":@"] = this.buildAttributesMap(f, s, o)), this.addChild(r, y, s), r = y;
          }
          n = "", a = h;
        }
      }
    else
      n += e[a];
  return t.child;
};
function ca(e, t, r) {
  const n = this.options.updateTag(t.tagname, r, t[":@"]);
  n === !1 || (typeof n == "string" && (t.tagname = n), e.addChild(t));
}
const fa = function(e) {
  if (this.options.processEntities) {
    for (let t in this.docTypeEntities) {
      const r = this.docTypeEntities[t];
      e = e.replace(r.regx, r.val);
    }
    for (let t in this.lastEntities) {
      const r = this.lastEntities[t];
      e = e.replace(r.regex, r.val);
    }
    if (this.options.htmlEntities)
      for (let t in this.htmlEntities) {
        const r = this.htmlEntities[t];
        e = e.replace(r.regex, r.val);
      }
    e = e.replace(this.ampEntity.regex, this.ampEntity.val);
  }
  return e;
};
function da(e, t, r, n) {
  return e && (n === void 0 && (n = Object.keys(t.child).length === 0), e = this.parseTextData(
    e,
    t.tagname,
    r,
    !1,
    t[":@"] ? Object.keys(t[":@"]).length !== 0 : !1,
    n
  ), e !== void 0 && e !== "" && t.add(this.options.textNodeName, e), e = ""), e;
}
function pa(e, t, r) {
  const n = "*." + r;
  for (const s in e) {
    const a = e[s];
    if (n === a || t === a)
      return !0;
  }
  return !1;
}
function ga(e, t, r = ">") {
  let n, s = "";
  for (let a = t; a < e.length; a++) {
    let l = e[a];
    if (n)
      l === n && (n = "");
    else if (l === '"' || l === "'")
      n = l;
    else if (l === r[0])
      if (r[1]) {
        if (e[a + 1] === r[1])
          return {
            data: s,
            index: a
          };
      } else
        return {
          data: s,
          index: a
        };
    else
      l === "	" && (l = " ");
    s += l;
  }
}
function W(e, t, r, n) {
  const s = e.indexOf(t, r);
  if (s === -1)
    throw new Error(n);
  return s + t.length - 1;
}
function qe(e, t, r, n = ">") {
  const s = ga(e, t + 1, n);
  if (!s)
    return;
  let a = s.data;
  const l = s.index, u = a.search(/\s/);
  let o = a, c = !0;
  u !== -1 && (o = a.substring(0, u), a = a.substring(u + 1).trimStart());
  const f = o;
  if (r) {
    const p = o.indexOf(":");
    p !== -1 && (o = o.substr(p + 1), c = o !== s.data.substr(p + 1));
  }
  return {
    tagName: o,
    tagExp: a,
    closeIndex: l,
    attrExpPresent: c,
    rawTagName: f
  };
}
function ha(e, t, r) {
  const n = r;
  let s = 1;
  for (; r < e.length; r++)
    if (e[r] === "<")
      if (e[r + 1] === "/") {
        const a = W(e, ">", r, `${t} is not closed`);
        if (e.substring(r + 2, a).trim() === t && (s--, s === 0))
          return {
            tagContent: e.substring(n, r),
            i: a
          };
        r = a;
      } else if (e[r + 1] === "?")
        r = W(e, "?>", r + 1, "StopNode is not closed.");
      else if (e.substr(r + 1, 3) === "!--")
        r = W(e, "-->", r + 3, "StopNode is not closed.");
      else if (e.substr(r + 1, 2) === "![")
        r = W(e, "]]>", r, "StopNode is not closed.") - 2;
      else {
        const a = qe(e, r, ">");
        a && ((a && a.tagName) === t && a.tagExp[a.tagExp.length - 1] !== "/" && s++, r = a.closeIndex);
      }
}
function He(e, t, r) {
  if (t && typeof e == "string") {
    const n = e.trim();
    return n === "true" ? !0 : n === "false" ? !1 : ta(e, r);
  } else
    return Dr.isExist(e) ? e : "";
}
var va = na, en = {};
function ba(e, t) {
  return tn(e, t);
}
function tn(e, t, r) {
  let n;
  const s = {};
  for (let a = 0; a < e.length; a++) {
    const l = e[a], u = ya(l);
    let o = "";
    if (r === void 0 ? o = u : o = r + "." + u, u === t.textNodeName)
      n === void 0 ? n = l[u] : n += "" + l[u];
    else {
      if (u === void 0)
        continue;
      if (l[u]) {
        let c = tn(l[u], t, o);
        const f = _a(c, t);
        l[":@"] ? $a(c, l[":@"], o, t) : Object.keys(c).length === 1 && c[t.textNodeName] !== void 0 && !t.alwaysCreateTextNode ? c = c[t.textNodeName] : Object.keys(c).length === 0 && (t.alwaysCreateTextNode ? c[t.textNodeName] = "" : c = ""), s[u] !== void 0 && s.hasOwnProperty(u) ? (Array.isArray(s[u]) || (s[u] = [s[u]]), s[u].push(c)) : t.isArray(u, o, f) ? s[u] = [c] : s[u] = c;
      }
    }
  }
  return typeof n == "string" ? n.length > 0 && (s[t.textNodeName] = n) : n !== void 0 && (s[t.textNodeName] = n), s;
}
function ya(e) {
  const t = Object.keys(e);
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (n !== ":@")
      return n;
  }
}
function $a(e, t, r, n) {
  if (t) {
    const s = Object.keys(t), a = s.length;
    for (let l = 0; l < a; l++) {
      const u = s[l];
      n.isArray(u, r + "." + u, !0, !0) ? e[u] = [t[u]] : e[u] = t[u];
    }
  }
}
function _a(e, t) {
  const { textNodeName: r } = t, n = Object.keys(e).length;
  return !!(n === 0 || n === 1 && (e[r] || typeof e[r] == "boolean" || e[r] === 0));
}
en.prettify = ba;
const { buildOptions: Ta } = at, ma = va, { prettify: Ea } = en, Aa = nt;
let Oa = class {
  constructor(t) {
    this.externalEntities = {}, this.options = Ta(t);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */
  parse(t, r) {
    if (typeof t != "string")
      if (t.toString)
        t = t.toString();
      else
        throw new Error("XML data is accepted in String or Bytes[] form.");
    if (r) {
      r === !0 && (r = {});
      const a = Aa.validate(t, r);
      if (a !== !0)
        throw Error(`${a.err.msg}:${a.err.line}:${a.err.col}`);
    }
    const n = new ma(this.options);
    n.addExternalEntities(this.externalEntities);
    const s = n.parseXml(t);
    return this.options.preserveOrder || s === void 0 ? s : Ea(s, this.options);
  }
  /**
   * Add Entity which is not by default supported by this library
   * @param {string} key 
   * @param {string} value 
   */
  addEntity(t, r) {
    if (r.indexOf("&") !== -1)
      throw new Error("Entity value can't have '&'");
    if (t.indexOf("&") !== -1 || t.indexOf(";") !== -1)
      throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
    if (r === "&")
      throw new Error("An entity with value '&' is not permitted");
    this.externalEntities[t] = r;
  }
};
var Ca = Oa;
const wa = `
`;
function Na(e, t) {
  let r = "";
  return t.format && t.indentBy.length > 0 && (r = wa), rn(e, t, "", r);
}
function rn(e, t, r, n) {
  let s = "", a = !1;
  for (let l = 0; l < e.length; l++) {
    const u = e[l], o = Pa(u);
    if (o === void 0)
      continue;
    let c = "";
    if (r.length === 0 ? c = o : c = `${r}.${o}`, o === t.textNodeName) {
      let y = u[o];
      Sa(c, t) || (y = t.tagValueProcessor(o, y), y = nn(y, t)), a && (s += n), s += y, a = !1;
      continue;
    } else if (o === t.cdataPropName) {
      a && (s += n), s += `<![CDATA[${u[o][0][t.textNodeName]}]]>`, a = !1;
      continue;
    } else if (o === t.commentPropName) {
      s += n + `<!--${u[o][0][t.textNodeName]}-->`, a = !0;
      continue;
    } else if (o[0] === "?") {
      const y = er(u[":@"], t), N = o === "?xml" ? "" : n;
      let E = u[o][0][t.textNodeName];
      E = E.length !== 0 ? " " + E : "", s += N + `<${o}${E}${y}?>`, a = !0;
      continue;
    }
    let f = n;
    f !== "" && (f += t.indentBy);
    const p = er(u[":@"], t), h = n + `<${o}${p}`, $ = rn(u[o], t, c, f);
    t.unpairedTags.indexOf(o) !== -1 ? t.suppressUnpairedNode ? s += h + ">" : s += h + "/>" : (!$ || $.length === 0) && t.suppressEmptyNode ? s += h + "/>" : $ && $.endsWith(">") ? s += h + `>${$}${n}</${o}>` : (s += h + ">", $ && n !== "" && ($.includes("/>") || $.includes("</")) ? s += n + t.indentBy + $ + n : s += $, s += `</${o}>`), a = !0;
  }
  return s;
}
function Pa(e) {
  const t = Object.keys(e);
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (e.hasOwnProperty(n) && n !== ":@")
      return n;
  }
}
function er(e, t) {
  let r = "";
  if (e && !t.ignoreAttributes)
    for (let n in e) {
      if (!e.hasOwnProperty(n))
        continue;
      let s = t.attributeValueProcessor(n, e[n]);
      s = nn(s, t), s === !0 && t.suppressBooleanAttributes ? r += ` ${n.substr(t.attributeNamePrefix.length)}` : r += ` ${n.substr(t.attributeNamePrefix.length)}="${s}"`;
    }
  return r;
}
function Sa(e, t) {
  e = e.substr(0, e.length - t.textNodeName.length - 1);
  let r = e.substr(e.lastIndexOf(".") + 1);
  for (let n in t.stopNodes)
    if (t.stopNodes[n] === e || t.stopNodes[n] === "*." + r)
      return !0;
  return !1;
}
function nn(e, t) {
  if (e && e.length > 0 && t.processEntities)
    for (let r = 0; r < t.entities.length; r++) {
      const n = t.entities[r];
      e = e.replace(n.regex, n.val);
    }
  return e;
}
var xa = Na;
const ja = xa, Ia = Qr, Ra = {
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  cdataPropName: !1,
  format: !1,
  indentBy: "  ",
  suppressEmptyNode: !1,
  suppressUnpairedNode: !0,
  suppressBooleanAttributes: !0,
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  preserveOrder: !1,
  commentPropName: !1,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },
    //it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("'", "g"), val: "&apos;" },
    { regex: new RegExp('"', "g"), val: "&quot;" }
  ],
  processEntities: !0,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: !1
};
function V(e) {
  this.options = Object.assign({}, Ra, e), this.options.ignoreAttributes === !0 || this.options.attributesGroupName ? this.isAttribute = function() {
    return !1;
  } : (this.ignoreAttributesFn = Ia(this.options.ignoreAttributes), this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = Ma), this.processTextOrObjNode = Fa, this.options.format ? (this.indentate = La, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
V.prototype.build = function(e) {
  return this.options.preserveOrder ? ja(e, this.options) : (Array.isArray(e) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (e = {
    [this.options.arrayNodeName]: e
  }), this.j2x(e, 0, []).val);
};
V.prototype.j2x = function(e, t, r) {
  let n = "", s = "";
  const a = r.join(".");
  for (let l in e)
    if (Object.prototype.hasOwnProperty.call(e, l))
      if (typeof e[l] > "u")
        this.isAttribute(l) && (s += "");
      else if (e[l] === null)
        this.isAttribute(l) ? s += "" : l[0] === "?" ? s += this.indentate(t) + "<" + l + "?" + this.tagEndChar : s += this.indentate(t) + "<" + l + "/" + this.tagEndChar;
      else if (e[l] instanceof Date)
        s += this.buildTextValNode(e[l], l, "", t);
      else if (typeof e[l] != "object") {
        const u = this.isAttribute(l);
        if (u && !this.ignoreAttributesFn(u, a))
          n += this.buildAttrPairStr(u, "" + e[l]);
        else if (!u)
          if (l === this.options.textNodeName) {
            let o = this.options.tagValueProcessor(l, "" + e[l]);
            s += this.replaceEntitiesValue(o);
          } else
            s += this.buildTextValNode(e[l], l, "", t);
      } else if (Array.isArray(e[l])) {
        const u = e[l].length;
        let o = "", c = "";
        for (let f = 0; f < u; f++) {
          const p = e[l][f];
          if (!(typeof p > "u"))
            if (p === null)
              l[0] === "?" ? s += this.indentate(t) + "<" + l + "?" + this.tagEndChar : s += this.indentate(t) + "<" + l + "/" + this.tagEndChar;
            else if (typeof p == "object")
              if (this.options.oneListGroup) {
                const h = this.j2x(p, t + 1, r.concat(l));
                o += h.val, this.options.attributesGroupName && p.hasOwnProperty(this.options.attributesGroupName) && (c += h.attrStr);
              } else
                o += this.processTextOrObjNode(p, l, t, r);
            else if (this.options.oneListGroup) {
              let h = this.options.tagValueProcessor(l, p);
              h = this.replaceEntitiesValue(h), o += h;
            } else
              o += this.buildTextValNode(p, l, "", t);
        }
        this.options.oneListGroup && (o = this.buildObjectNode(o, l, c, t)), s += o;
      } else if (this.options.attributesGroupName && l === this.options.attributesGroupName) {
        const u = Object.keys(e[l]), o = u.length;
        for (let c = 0; c < o; c++)
          n += this.buildAttrPairStr(u[c], "" + e[l][u[c]]);
      } else
        s += this.processTextOrObjNode(e[l], l, t, r);
  return { attrStr: n, val: s };
};
V.prototype.buildAttrPairStr = function(e, t) {
  return t = this.options.attributeValueProcessor(e, "" + t), t = this.replaceEntitiesValue(t), this.options.suppressBooleanAttributes && t === "true" ? " " + e : " " + e + '="' + t + '"';
};
function Fa(e, t, r, n) {
  const s = this.j2x(e, r + 1, n.concat(t));
  return e[this.options.textNodeName] !== void 0 && Object.keys(e).length === 1 ? this.buildTextValNode(e[this.options.textNodeName], t, s.attrStr, r) : this.buildObjectNode(s.val, t, s.attrStr, r);
}
V.prototype.buildObjectNode = function(e, t, r, n) {
  if (e === "")
    return t[0] === "?" ? this.indentate(n) + "<" + t + r + "?" + this.tagEndChar : this.indentate(n) + "<" + t + r + this.closeTag(t) + this.tagEndChar;
  {
    let s = "</" + t + this.tagEndChar, a = "";
    return t[0] === "?" && (a = "?", s = ""), (r || r === "") && e.indexOf("<") === -1 ? this.indentate(n) + "<" + t + r + a + ">" + e + s : this.options.commentPropName !== !1 && t === this.options.commentPropName && a.length === 0 ? this.indentate(n) + `<!--${e}-->` + this.newLine : this.indentate(n) + "<" + t + r + a + this.tagEndChar + e + this.indentate(n) + s;
  }
};
V.prototype.closeTag = function(e) {
  let t = "";
  return this.options.unpairedTags.indexOf(e) !== -1 ? this.options.suppressUnpairedNode || (t = "/") : this.options.suppressEmptyNode ? t = "/" : t = `></${e}`, t;
};
V.prototype.buildTextValNode = function(e, t, r, n) {
  if (this.options.cdataPropName !== !1 && t === this.options.cdataPropName)
    return this.indentate(n) + `<![CDATA[${e}]]>` + this.newLine;
  if (this.options.commentPropName !== !1 && t === this.options.commentPropName)
    return this.indentate(n) + `<!--${e}-->` + this.newLine;
  if (t[0] === "?")
    return this.indentate(n) + "<" + t + r + "?" + this.tagEndChar;
  {
    let s = this.options.tagValueProcessor(t, e);
    return s = this.replaceEntitiesValue(s), s === "" ? this.indentate(n) + "<" + t + r + this.closeTag(t) + this.tagEndChar : this.indentate(n) + "<" + t + r + ">" + s + "</" + t + this.tagEndChar;
  }
};
V.prototype.replaceEntitiesValue = function(e) {
  if (e && e.length > 0 && this.options.processEntities)
    for (let t = 0; t < this.options.entities.length; t++) {
      const r = this.options.entities[t];
      e = e.replace(r.regex, r.val);
    }
  return e;
};
function La(e) {
  return this.options.indentBy.repeat(e);
}
function Ma(e) {
  return e.startsWith(this.options.attributeNamePrefix) && e !== this.options.textNodeName ? e.substr(this.attrPrefixLen) : !1;
}
var Ba = V;
const Ga = nt, Va = Ca, Ua = Ba;
var sn = {
  XMLParser: Va,
  XMLValidator: Ga,
  XMLBuilder: Ua
};
const ka = new sn.XMLParser({
  preserveOrder: !0,
  ignoreAttributes: !1,
  attributeNamePrefix: "",
  allowBooleanAttributes: !0,
  commentPropName: tt,
  cdataPropName: rt,
  parseTagValue: !1
});
function Ka(e) {
  return Yr(() => {
    try {
      if (!sn.XMLValidator.validate(e))
        throw new Error("Invalid XML!");
      const t = ka.parse(e);
      if (typeof e == "string" && e.trim().length > 0 && t.length === 0)
        throw new Error("Invalid XML!");
      return { json: t, valid: !0 };
    } catch (t) {
      return { json: null, valid: !1, errorMessage: `Fail to parse: ${t.message}` };
    }
  }, [e]);
}
function Xa() {
  this.__data__ = [], this.size = 0;
}
var Wa = Xa;
function Ya(e, t) {
  return e === t || e !== e && t !== t;
}
var it = Ya, qa = it;
function Ha(e, t) {
  for (var r = e.length; r--; )
    if (qa(e[r][0], t))
      return r;
  return -1;
}
var Pe = Ha, za = Pe, Ja = Array.prototype, Za = Ja.splice;
function Qa(e) {
  var t = this.__data__, r = za(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Za.call(t, r, 1), --this.size, !0;
}
var Da = Qa, ei = Pe;
function ti(e) {
  var t = this.__data__, r = ei(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var ri = ti, ni = Pe;
function si(e) {
  return ni(this.__data__, e) > -1;
}
var ai = si, ii = Pe;
function oi(e, t) {
  var r = this.__data__, n = ii(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var ui = oi, li = Wa, ci = Da, fi = ri, di = ai, pi = ui;
function Z(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Z.prototype.clear = li;
Z.prototype.delete = ci;
Z.prototype.get = fi;
Z.prototype.has = di;
Z.prototype.set = pi;
var Se = Z, gi = Se;
function hi() {
  this.__data__ = new gi(), this.size = 0;
}
var vi = hi;
function bi(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var yi = bi;
function $i(e) {
  return this.__data__.get(e);
}
var _i = $i;
function Ti(e) {
  return this.__data__.has(e);
}
var mi = Ti, Ei = typeof $e == "object" && $e && $e.Object === Object && $e, an = Ei, Ai = an, Oi = typeof self == "object" && self && self.Object === Object && self, Ci = Ai || Oi || Function("return this")(), L = Ci, wi = L, Ni = wi.Symbol, Q = Ni, tr = Q, on = Object.prototype, Pi = on.hasOwnProperty, Si = on.toString, ce = tr ? tr.toStringTag : void 0;
function xi(e) {
  var t = Pi.call(e, ce), r = e[ce];
  try {
    e[ce] = void 0;
    var n = !0;
  } catch {
  }
  var s = Si.call(e);
  return n && (t ? e[ce] = r : delete e[ce]), s;
}
var ji = xi, Ii = Object.prototype, Ri = Ii.toString;
function Fi(e) {
  return Ri.call(e);
}
var Li = Fi, rr = Q, Mi = ji, Bi = Li, Gi = "[object Null]", Vi = "[object Undefined]", nr = rr ? rr.toStringTag : void 0;
function Ui(e) {
  return e == null ? e === void 0 ? Vi : Gi : nr && nr in Object(e) ? Mi(e) : Bi(e);
}
var D = Ui;
function ki(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var fe = ki, Ki = D, Xi = fe, Wi = "[object AsyncFunction]", Yi = "[object Function]", qi = "[object GeneratorFunction]", Hi = "[object Proxy]";
function zi(e) {
  if (!Xi(e))
    return !1;
  var t = Ki(e);
  return t == Yi || t == qi || t == Wi || t == Hi;
}
var un = zi, Ji = L, Zi = Ji["__core-js_shared__"], Qi = Zi, ke = Qi, sr = function() {
  var e = /[^.]+$/.exec(ke && ke.keys && ke.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Di(e) {
  return !!sr && sr in e;
}
var eo = Di, to = Function.prototype, ro = to.toString;
function no(e) {
  if (e != null) {
    try {
      return ro.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ln = no, so = un, ao = eo, io = fe, oo = ln, uo = /[\\^$.*+?()[\]{}|]/g, lo = /^\[object .+?Constructor\]$/, co = Function.prototype, fo = Object.prototype, po = co.toString, go = fo.hasOwnProperty, ho = RegExp(
  "^" + po.call(go).replace(uo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function vo(e) {
  if (!io(e) || ao(e))
    return !1;
  var t = so(e) ? ho : lo;
  return t.test(oo(e));
}
var bo = vo;
function yo(e, t) {
  return e == null ? void 0 : e[t];
}
var $o = yo, _o = bo, To = $o;
function mo(e, t) {
  var r = To(e, t);
  return _o(r) ? r : void 0;
}
var Y = mo, Eo = Y, Ao = L, Oo = Eo(Ao, "Map"), ot = Oo, Co = Y, wo = Co(Object, "create"), xe = wo, ar = xe;
function No() {
  this.__data__ = ar ? ar(null) : {}, this.size = 0;
}
var Po = No;
function So(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var xo = So, jo = xe, Io = "__lodash_hash_undefined__", Ro = Object.prototype, Fo = Ro.hasOwnProperty;
function Lo(e) {
  var t = this.__data__;
  if (jo) {
    var r = t[e];
    return r === Io ? void 0 : r;
  }
  return Fo.call(t, e) ? t[e] : void 0;
}
var Mo = Lo, Bo = xe, Go = Object.prototype, Vo = Go.hasOwnProperty;
function Uo(e) {
  var t = this.__data__;
  return Bo ? t[e] !== void 0 : Vo.call(t, e);
}
var ko = Uo, Ko = xe, Xo = "__lodash_hash_undefined__";
function Wo(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Ko && t === void 0 ? Xo : t, this;
}
var Yo = Wo, qo = Po, Ho = xo, zo = Mo, Jo = ko, Zo = Yo;
function ee(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ee.prototype.clear = qo;
ee.prototype.delete = Ho;
ee.prototype.get = zo;
ee.prototype.has = Jo;
ee.prototype.set = Zo;
var Qo = ee, ir = Qo, Do = Se, eu = ot;
function tu() {
  this.size = 0, this.__data__ = {
    hash: new ir(),
    map: new (eu || Do)(),
    string: new ir()
  };
}
var ru = tu;
function nu(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var su = nu, au = su;
function iu(e, t) {
  var r = e.__data__;
  return au(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var je = iu, ou = je;
function uu(e) {
  var t = ou(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var lu = uu, cu = je;
function fu(e) {
  return cu(this, e).get(e);
}
var du = fu, pu = je;
function gu(e) {
  return pu(this, e).has(e);
}
var hu = gu, vu = je;
function bu(e, t) {
  var r = vu(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var yu = bu, $u = ru, _u = lu, Tu = du, mu = hu, Eu = yu;
function te(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
te.prototype.clear = $u;
te.prototype.delete = _u;
te.prototype.get = Tu;
te.prototype.has = mu;
te.prototype.set = Eu;
var ut = te, Au = Se, Ou = ot, Cu = ut, wu = 200;
function Nu(e, t) {
  var r = this.__data__;
  if (r instanceof Au) {
    var n = r.__data__;
    if (!Ou || n.length < wu - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Cu(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Pu = Nu, Su = Se, xu = vi, ju = yi, Iu = _i, Ru = mi, Fu = Pu;
function re(e) {
  var t = this.__data__ = new Su(e);
  this.size = t.size;
}
re.prototype.clear = xu;
re.prototype.delete = ju;
re.prototype.get = Iu;
re.prototype.has = Ru;
re.prototype.set = Fu;
var cn = re, Lu = "__lodash_hash_undefined__";
function Mu(e) {
  return this.__data__.set(e, Lu), this;
}
var Bu = Mu;
function Gu(e) {
  return this.__data__.has(e);
}
var Vu = Gu, Uu = ut, ku = Bu, Ku = Vu;
function Ae(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Uu(); ++t < r; )
    this.add(e[t]);
}
Ae.prototype.add = Ae.prototype.push = ku;
Ae.prototype.has = Ku;
var Xu = Ae;
function Wu(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Yu = Wu;
function qu(e, t) {
  return e.has(t);
}
var Hu = qu, zu = Xu, Ju = Yu, Zu = Hu, Qu = 1, Du = 2;
function el(e, t, r, n, s, a) {
  var l = r & Qu, u = e.length, o = t.length;
  if (u != o && !(l && o > u))
    return !1;
  var c = a.get(e), f = a.get(t);
  if (c && f)
    return c == t && f == e;
  var p = -1, h = !0, $ = r & Du ? new zu() : void 0;
  for (a.set(e, t), a.set(t, e); ++p < u; ) {
    var y = e[p], N = t[p];
    if (n)
      var E = l ? n(N, y, p, t, e, a) : n(y, N, p, e, t, a);
    if (E !== void 0) {
      if (E)
        continue;
      h = !1;
      break;
    }
    if ($) {
      if (!Ju(t, function(P, w) {
        if (!Zu($, w) && (y === P || s(y, P, r, n, a)))
          return $.push(w);
      })) {
        h = !1;
        break;
      }
    } else if (!(y === N || s(y, N, r, n, a))) {
      h = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), h;
}
var fn = el, tl = L, rl = tl.Uint8Array, dn = rl;
function nl(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, s) {
    r[++t] = [s, n];
  }), r;
}
var sl = nl;
function al(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var il = al, or = Q, ur = dn, ol = it, ul = fn, ll = sl, cl = il, fl = 1, dl = 2, pl = "[object Boolean]", gl = "[object Date]", hl = "[object Error]", vl = "[object Map]", bl = "[object Number]", yl = "[object RegExp]", $l = "[object Set]", _l = "[object String]", Tl = "[object Symbol]", ml = "[object ArrayBuffer]", El = "[object DataView]", lr = or ? or.prototype : void 0, Ke = lr ? lr.valueOf : void 0;
function Al(e, t, r, n, s, a, l) {
  switch (r) {
    case El:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ml:
      return !(e.byteLength != t.byteLength || !a(new ur(e), new ur(t)));
    case pl:
    case gl:
    case bl:
      return ol(+e, +t);
    case hl:
      return e.name == t.name && e.message == t.message;
    case yl:
    case _l:
      return e == t + "";
    case vl:
      var u = ll;
    case $l:
      var o = n & fl;
      if (u || (u = cl), e.size != t.size && !o)
        return !1;
      var c = l.get(e);
      if (c)
        return c == t;
      n |= dl, l.set(e, t);
      var f = ul(u(e), u(t), n, s, a, l);
      return l.delete(e), f;
    case Tl:
      if (Ke)
        return Ke.call(e) == Ke.call(t);
  }
  return !1;
}
var Ol = Al;
function Cl(e, t) {
  for (var r = -1, n = t.length, s = e.length; ++r < n; )
    e[s + r] = t[r];
  return e;
}
var lt = Cl, wl = Array.isArray, U = wl, Nl = lt, Pl = U;
function Sl(e, t, r) {
  var n = t(e);
  return Pl(e) ? n : Nl(n, r(e));
}
var pn = Sl;
function xl(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, s = 0, a = []; ++r < n; ) {
    var l = e[r];
    t(l, r, e) && (a[s++] = l);
  }
  return a;
}
var jl = xl;
function Il() {
  return [];
}
var gn = Il, Rl = jl, Fl = gn, Ll = Object.prototype, Ml = Ll.propertyIsEnumerable, cr = Object.getOwnPropertySymbols, Bl = cr ? function(e) {
  return e == null ? [] : (e = Object(e), Rl(cr(e), function(t) {
    return Ml.call(e, t);
  }));
} : Fl, ct = Bl;
function Gl(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Vl = Gl;
function Ul(e) {
  return e != null && typeof e == "object";
}
var k = Ul, kl = D, Kl = k, Xl = "[object Arguments]";
function Wl(e) {
  return Kl(e) && kl(e) == Xl;
}
var Yl = Wl, fr = Yl, ql = k, hn = Object.prototype, Hl = hn.hasOwnProperty, zl = hn.propertyIsEnumerable, Jl = fr(function() {
  return arguments;
}()) ? fr : function(e) {
  return ql(e) && Hl.call(e, "callee") && !zl.call(e, "callee");
}, vn = Jl, Oe = { exports: {} };
function Zl() {
  return !1;
}
var Ql = Zl;
Oe.exports;
(function(e, t) {
  var r = L, n = Ql, s = t && !t.nodeType && t, a = s && !0 && e && !e.nodeType && e, l = a && a.exports === s, u = l ? r.Buffer : void 0, o = u ? u.isBuffer : void 0, c = o || n;
  e.exports = c;
})(Oe, Oe.exports);
var ft = Oe.exports, Dl = 9007199254740991, ec = /^(?:0|[1-9]\d*)$/;
function tc(e, t) {
  var r = typeof e;
  return t = t ?? Dl, !!t && (r == "number" || r != "symbol" && ec.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var rc = tc, nc = 9007199254740991;
function sc(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= nc;
}
var bn = sc, ac = D, ic = bn, oc = k, uc = "[object Arguments]", lc = "[object Array]", cc = "[object Boolean]", fc = "[object Date]", dc = "[object Error]", pc = "[object Function]", gc = "[object Map]", hc = "[object Number]", vc = "[object Object]", bc = "[object RegExp]", yc = "[object Set]", $c = "[object String]", _c = "[object WeakMap]", Tc = "[object ArrayBuffer]", mc = "[object DataView]", Ec = "[object Float32Array]", Ac = "[object Float64Array]", Oc = "[object Int8Array]", Cc = "[object Int16Array]", wc = "[object Int32Array]", Nc = "[object Uint8Array]", Pc = "[object Uint8ClampedArray]", Sc = "[object Uint16Array]", xc = "[object Uint32Array]", C = {};
C[Ec] = C[Ac] = C[Oc] = C[Cc] = C[wc] = C[Nc] = C[Pc] = C[Sc] = C[xc] = !0;
C[uc] = C[lc] = C[Tc] = C[cc] = C[mc] = C[fc] = C[dc] = C[pc] = C[gc] = C[hc] = C[vc] = C[bc] = C[yc] = C[$c] = C[_c] = !1;
function jc(e) {
  return oc(e) && ic(e.length) && !!C[ac(e)];
}
var Ic = jc;
function Rc(e) {
  return function(t) {
    return e(t);
  };
}
var dt = Rc, Ce = { exports: {} };
Ce.exports;
(function(e, t) {
  var r = an, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, a = s && s.exports === n, l = a && r.process, u = function() {
    try {
      var o = s && s.require && s.require("util").types;
      return o || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  e.exports = u;
})(Ce, Ce.exports);
var pt = Ce.exports, Fc = Ic, Lc = dt, dr = pt, pr = dr && dr.isTypedArray, Mc = pr ? Lc(pr) : Fc, yn = Mc, Bc = Vl, Gc = vn, Vc = U, Uc = ft, kc = rc, Kc = yn, Xc = Object.prototype, Wc = Xc.hasOwnProperty;
function Yc(e, t) {
  var r = Vc(e), n = !r && Gc(e), s = !r && !n && Uc(e), a = !r && !n && !s && Kc(e), l = r || n || s || a, u = l ? Bc(e.length, String) : [], o = u.length;
  for (var c in e)
    (t || Wc.call(e, c)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    kc(c, o))) && u.push(c);
  return u;
}
var $n = Yc, qc = Object.prototype;
function Hc(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || qc;
  return e === r;
}
var gt = Hc;
function zc(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var _n = zc, Jc = _n, Zc = Jc(Object.keys, Object), Qc = Zc, Dc = gt, ef = Qc, tf = Object.prototype, rf = tf.hasOwnProperty;
function nf(e) {
  if (!Dc(e))
    return ef(e);
  var t = [];
  for (var r in Object(e))
    rf.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var sf = nf, af = un, of = bn;
function uf(e) {
  return e != null && of(e.length) && !af(e);
}
var Tn = uf, lf = $n, cf = sf, ff = Tn;
function df(e) {
  return ff(e) ? lf(e) : cf(e);
}
var ht = df, pf = pn, gf = ct, hf = ht;
function vf(e) {
  return pf(e, hf, gf);
}
var mn = vf, gr = mn, bf = 1, yf = Object.prototype, $f = yf.hasOwnProperty;
function _f(e, t, r, n, s, a) {
  var l = r & bf, u = gr(e), o = u.length, c = gr(t), f = c.length;
  if (o != f && !l)
    return !1;
  for (var p = o; p--; ) {
    var h = u[p];
    if (!(l ? h in t : $f.call(t, h)))
      return !1;
  }
  var $ = a.get(e), y = a.get(t);
  if ($ && y)
    return $ == t && y == e;
  var N = !0;
  a.set(e, t), a.set(t, e);
  for (var E = l; ++p < o; ) {
    h = u[p];
    var P = e[h], w = t[h];
    if (n)
      var pe = l ? n(w, P, h, t, e, a) : n(P, w, h, e, t, a);
    if (!(pe === void 0 ? P === w || s(P, w, r, n, a) : pe)) {
      N = !1;
      break;
    }
    E || (E = h == "constructor");
  }
  if (N && !E) {
    var q = e.constructor, H = t.constructor;
    q != H && "constructor" in e && "constructor" in t && !(typeof q == "function" && q instanceof q && typeof H == "function" && H instanceof H) && (N = !1);
  }
  return a.delete(e), a.delete(t), N;
}
var Tf = _f, mf = Y, Ef = L, Af = mf(Ef, "DataView"), Of = Af, Cf = Y, wf = L, Nf = Cf(wf, "Promise"), Pf = Nf, Sf = Y, xf = L, jf = Sf(xf, "Set"), If = jf, Rf = Y, Ff = L, Lf = Rf(Ff, "WeakMap"), Mf = Lf, ze = Of, Je = ot, Ze = Pf, Qe = If, De = Mf, En = D, ne = ln, hr = "[object Map]", Bf = "[object Object]", vr = "[object Promise]", br = "[object Set]", yr = "[object WeakMap]", $r = "[object DataView]", Gf = ne(ze), Vf = ne(Je), Uf = ne(Ze), kf = ne(Qe), Kf = ne(De), X = En;
(ze && X(new ze(new ArrayBuffer(1))) != $r || Je && X(new Je()) != hr || Ze && X(Ze.resolve()) != vr || Qe && X(new Qe()) != br || De && X(new De()) != yr) && (X = function(e) {
  var t = En(e), r = t == Bf ? e.constructor : void 0, n = r ? ne(r) : "";
  if (n)
    switch (n) {
      case Gf:
        return $r;
      case Vf:
        return hr;
      case Uf:
        return vr;
      case kf:
        return br;
      case Kf:
        return yr;
    }
  return t;
});
var Ie = X, Xe = cn, Xf = fn, Wf = Ol, Yf = Tf, _r = Ie, Tr = U, mr = ft, qf = yn, Hf = 1, Er = "[object Arguments]", Ar = "[object Array]", _e = "[object Object]", zf = Object.prototype, Or = zf.hasOwnProperty;
function Jf(e, t, r, n, s, a) {
  var l = Tr(e), u = Tr(t), o = l ? Ar : _r(e), c = u ? Ar : _r(t);
  o = o == Er ? _e : o, c = c == Er ? _e : c;
  var f = o == _e, p = c == _e, h = o == c;
  if (h && mr(e)) {
    if (!mr(t))
      return !1;
    l = !0, f = !1;
  }
  if (h && !f)
    return a || (a = new Xe()), l || qf(e) ? Xf(e, t, r, n, s, a) : Wf(e, t, o, r, n, s, a);
  if (!(r & Hf)) {
    var $ = f && Or.call(e, "__wrapped__"), y = p && Or.call(t, "__wrapped__");
    if ($ || y) {
      var N = $ ? e.value() : e, E = y ? t.value() : t;
      return a || (a = new Xe()), s(N, E, r, n, a);
    }
  }
  return h ? (a || (a = new Xe()), Yf(e, t, r, n, s, a)) : !1;
}
var Zf = Jf, Qf = Zf, Cr = k;
function An(e, t, r, n, s) {
  return e === t ? !0 : e == null || t == null || !Cr(e) && !Cr(t) ? e !== e && t !== t : Qf(e, t, r, n, An, s);
}
var Df = An, ed = Df;
function td(e, t) {
  return ed(e, t);
}
var rd = td;
const nd = /* @__PURE__ */ et(rd);
function sd(e) {
  const { indentation: t, children: r, isInline: n } = e, { theme: s } = G();
  return /* @__PURE__ */ v.jsxs("div", { style: { color: s.cdataColor }, children: [
    /* @__PURE__ */ v.jsx("span", { children: `${t}<![CDATA[` }),
    r,
    /* @__PURE__ */ v.jsx("span", { children: `${n ? "" : t}]]>` })
  ] });
}
const ad = (e) => /* @__PURE__ */ Yt.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ Yt.createElement("path", { d: "M9 17.898C9 18.972 10.2649 19.546 11.0731 18.8388L17.3838 13.3169C18.1806 12.6197 18.1806 11.3801 17.3838 10.6829L11.0731 5.16108C10.2649 4.45388 9 5.02785 9 6.1018V17.898Z" }));
function On(e) {
  const { collapsible: t, theme: r } = G(), { collapsed: n } = e;
  return t ? /* @__PURE__ */ v.jsx("span", { style: { position: "relative" }, children: /* @__PURE__ */ v.jsx("span", { style: { position: "absolute", right: "0", border: 0, padding: 0, background: "none" }, children: /* @__PURE__ */ v.jsx(
    ad,
    {
      fill: r.separatorColor,
      style: { transform: `rotate(${n ? 0 : 90}deg)`, transition: "transform 0.2s" }
    }
  ) }) }) : null;
}
function id(e) {
  return e == null;
}
var od = id;
const wr = /* @__PURE__ */ et(od);
function Cn(e) {
  const { collapsible: t, initialCollapsedDepth: r } = G(), [n, s] = qr(
    () => wr(r) || !t ? !1 : e >= r
  ), a = () => s((l) => !l);
  return Hr(() => {
    s(
      wr(r) || !t ? !1 : e >= r
    );
  }, [r, e, t]), {
    collapsed: n,
    buttonProps: t ? {
      onClick: a,
      role: "button",
      style: { cursor: "pointer" }
    } : {}
  };
}
function ud(e) {
  const { indentation: t, children: r, isInline: n, level: s } = e, { theme: a } = G(), { collapsed: l, buttonProps: u } = Cn(s);
  return /* @__PURE__ */ v.jsxs("div", { style: { color: a.commentColor }, children: [
    /* @__PURE__ */ v.jsxs("span", { ...u, children: [
      /* @__PURE__ */ v.jsx("span", { children: t }),
      /* @__PURE__ */ v.jsx(On, { collapsed: l }),
      /* @__PURE__ */ v.jsx("span", { children: "<!-- " })
    ] }),
    !l && r,
    l && "...",
    /* @__PURE__ */ v.jsx("span", { children: `${n || l ? " " : t}-->` })
  ] });
}
function wn(e) {
  const { attributes: t } = e, { theme: r } = G();
  return t ? /* @__PURE__ */ v.jsx("span", { children: Object.entries(t).map(([n, s]) => /* @__PURE__ */ v.jsxs("span", { children: [
    /* @__PURE__ */ v.jsx("span", { style: { color: r.attributeKeyColor }, children: ` ${n}` }),
    /* @__PURE__ */ v.jsx("span", { style: { color: r.separatorColor }, children: "=" }),
    /* @__PURE__ */ v.jsx("span", { style: { color: r.attributeValueColor }, children: `"${s}"` })
  ] }, `attribute-${n}`)) }) : null;
}
function ld(e) {
  const { indentation: t, tagKey: r, attributes: n } = e, { theme: s } = G();
  return /* @__PURE__ */ v.jsxs("div", { children: [
    /* @__PURE__ */ v.jsx("span", { style: { color: s.separatorColor }, children: `${t}<?` }),
    /* @__PURE__ */ v.jsx("span", { style: { color: s.tagColor }, children: `${r.slice(1)}` }),
    /* @__PURE__ */ v.jsx(wn, { attributes: n }),
    /* @__PURE__ */ v.jsx("span", { style: { color: s.separatorColor }, children: "?>" })
  ] });
}
function cd(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, s = Array(n); ++r < n; )
    s[r] = t(e[r], r, e);
  return s;
}
var Nn = cd;
function fd(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var dd = fd, pd = Y, gd = function() {
  try {
    var e = pd(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Pn = gd, Nr = Pn;
function hd(e, t, r) {
  t == "__proto__" && Nr ? Nr(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Sn = hd, vd = Sn, bd = it, yd = Object.prototype, $d = yd.hasOwnProperty;
function _d(e, t, r) {
  var n = e[t];
  (!($d.call(e, t) && bd(n, r)) || r === void 0 && !(t in e)) && vd(e, t, r);
}
var xn = _d, Td = xn, md = Sn;
function Ed(e, t, r, n) {
  var s = !r;
  r || (r = {});
  for (var a = -1, l = t.length; ++a < l; ) {
    var u = t[a], o = n ? n(r[u], e[u], u, r, e) : void 0;
    o === void 0 && (o = e[u]), s ? md(r, u, o) : Td(r, u, o);
  }
  return r;
}
var de = Ed, Ad = de, Od = ht;
function Cd(e, t) {
  return e && Ad(t, Od(t), e);
}
var wd = Cd;
function Nd(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Pd = Nd, Sd = fe, xd = gt, jd = Pd, Id = Object.prototype, Rd = Id.hasOwnProperty;
function Fd(e) {
  if (!Sd(e))
    return jd(e);
  var t = xd(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Rd.call(e, n)) || r.push(n);
  return r;
}
var Ld = Fd, Md = $n, Bd = Ld, Gd = Tn;
function Vd(e) {
  return Gd(e) ? Md(e, !0) : Bd(e);
}
var vt = Vd, Ud = de, kd = vt;
function Kd(e, t) {
  return e && Ud(t, kd(t), e);
}
var Xd = Kd, we = { exports: {} };
we.exports;
(function(e, t) {
  var r = L, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, a = s && s.exports === n, l = a ? r.Buffer : void 0, u = l ? l.allocUnsafe : void 0;
  function o(c, f) {
    if (f)
      return c.slice();
    var p = c.length, h = u ? u(p) : new c.constructor(p);
    return c.copy(h), h;
  }
  e.exports = o;
})(we, we.exports);
var Wd = we.exports;
function Yd(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var qd = Yd, Hd = de, zd = ct;
function Jd(e, t) {
  return Hd(e, zd(e), t);
}
var Zd = Jd, Qd = _n, Dd = Qd(Object.getPrototypeOf, Object), bt = Dd, ep = lt, tp = bt, rp = ct, np = gn, sp = Object.getOwnPropertySymbols, ap = sp ? function(e) {
  for (var t = []; e; )
    ep(t, rp(e)), e = tp(e);
  return t;
} : np, jn = ap, ip = de, op = jn;
function up(e, t) {
  return ip(e, op(e), t);
}
var lp = up, cp = pn, fp = jn, dp = vt;
function pp(e) {
  return cp(e, dp, fp);
}
var In = pp, gp = Object.prototype, hp = gp.hasOwnProperty;
function vp(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && hp.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var bp = vp, Pr = dn;
function yp(e) {
  var t = new e.constructor(e.byteLength);
  return new Pr(t).set(new Pr(e)), t;
}
var yt = yp, $p = yt;
function _p(e, t) {
  var r = t ? $p(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var Tp = _p, mp = /\w*$/;
function Ep(e) {
  var t = new e.constructor(e.source, mp.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Ap = Ep, Sr = Q, xr = Sr ? Sr.prototype : void 0, jr = xr ? xr.valueOf : void 0;
function Op(e) {
  return jr ? Object(jr.call(e)) : {};
}
var Cp = Op, wp = yt;
function Np(e, t) {
  var r = t ? wp(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var Pp = Np, Sp = yt, xp = Tp, jp = Ap, Ip = Cp, Rp = Pp, Fp = "[object Boolean]", Lp = "[object Date]", Mp = "[object Map]", Bp = "[object Number]", Gp = "[object RegExp]", Vp = "[object Set]", Up = "[object String]", kp = "[object Symbol]", Kp = "[object ArrayBuffer]", Xp = "[object DataView]", Wp = "[object Float32Array]", Yp = "[object Float64Array]", qp = "[object Int8Array]", Hp = "[object Int16Array]", zp = "[object Int32Array]", Jp = "[object Uint8Array]", Zp = "[object Uint8ClampedArray]", Qp = "[object Uint16Array]", Dp = "[object Uint32Array]";
function eg(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case Kp:
      return Sp(e);
    case Fp:
    case Lp:
      return new n(+e);
    case Xp:
      return xp(e, r);
    case Wp:
    case Yp:
    case qp:
    case Hp:
    case zp:
    case Jp:
    case Zp:
    case Qp:
    case Dp:
      return Rp(e, r);
    case Mp:
      return new n();
    case Bp:
    case Up:
      return new n(e);
    case Gp:
      return jp(e);
    case Vp:
      return new n();
    case kp:
      return Ip(e);
  }
}
var tg = eg, rg = fe, Ir = Object.create, ng = function() {
  function e() {
  }
  return function(t) {
    if (!rg(t))
      return {};
    if (Ir)
      return Ir(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), sg = ng, ag = sg, ig = bt, og = gt;
function ug(e) {
  return typeof e.constructor == "function" && !og(e) ? ag(ig(e)) : {};
}
var lg = ug, cg = Ie, fg = k, dg = "[object Map]";
function pg(e) {
  return fg(e) && cg(e) == dg;
}
var gg = pg, hg = gg, vg = dt, Rr = pt, Fr = Rr && Rr.isMap, bg = Fr ? vg(Fr) : hg, yg = bg, $g = Ie, _g = k, Tg = "[object Set]";
function mg(e) {
  return _g(e) && $g(e) == Tg;
}
var Eg = mg, Ag = Eg, Og = dt, Lr = pt, Mr = Lr && Lr.isSet, Cg = Mr ? Og(Mr) : Ag, wg = Cg, Ng = cn, Pg = dd, Sg = xn, xg = wd, jg = Xd, Ig = Wd, Rg = qd, Fg = Zd, Lg = lp, Mg = mn, Bg = In, Gg = Ie, Vg = bp, Ug = tg, kg = lg, Kg = U, Xg = ft, Wg = yg, Yg = fe, qg = wg, Hg = ht, zg = vt, Jg = 1, Zg = 2, Qg = 4, Rn = "[object Arguments]", Dg = "[object Array]", eh = "[object Boolean]", th = "[object Date]", rh = "[object Error]", Fn = "[object Function]", nh = "[object GeneratorFunction]", sh = "[object Map]", ah = "[object Number]", Ln = "[object Object]", ih = "[object RegExp]", oh = "[object Set]", uh = "[object String]", lh = "[object Symbol]", ch = "[object WeakMap]", fh = "[object ArrayBuffer]", dh = "[object DataView]", ph = "[object Float32Array]", gh = "[object Float64Array]", hh = "[object Int8Array]", vh = "[object Int16Array]", bh = "[object Int32Array]", yh = "[object Uint8Array]", $h = "[object Uint8ClampedArray]", _h = "[object Uint16Array]", Th = "[object Uint32Array]", O = {};
O[Rn] = O[Dg] = O[fh] = O[dh] = O[eh] = O[th] = O[ph] = O[gh] = O[hh] = O[vh] = O[bh] = O[sh] = O[ah] = O[Ln] = O[ih] = O[oh] = O[uh] = O[lh] = O[yh] = O[$h] = O[_h] = O[Th] = !0;
O[rh] = O[Fn] = O[ch] = !1;
function Te(e, t, r, n, s, a) {
  var l, u = t & Jg, o = t & Zg, c = t & Qg;
  if (r && (l = s ? r(e, n, s, a) : r(e)), l !== void 0)
    return l;
  if (!Yg(e))
    return e;
  var f = Kg(e);
  if (f) {
    if (l = Vg(e), !u)
      return Rg(e, l);
  } else {
    var p = Gg(e), h = p == Fn || p == nh;
    if (Xg(e))
      return Ig(e, u);
    if (p == Ln || p == Rn || h && !s) {
      if (l = o || h ? {} : kg(e), !u)
        return o ? Lg(e, jg(l, e)) : Fg(e, xg(l, e));
    } else {
      if (!O[p])
        return s ? e : {};
      l = Ug(e, p, u);
    }
  }
  a || (a = new Ng());
  var $ = a.get(e);
  if ($)
    return $;
  a.set(e, l), qg(e) ? e.forEach(function(E) {
    l.add(Te(E, t, r, E, e, a));
  }) : Wg(e) && e.forEach(function(E, P) {
    l.set(P, Te(E, t, r, P, e, a));
  });
  var y = c ? o ? Bg : Mg : o ? zg : Hg, N = f ? void 0 : y(e);
  return Pg(N || e, function(E, P) {
    N && (P = E, E = e[P]), Sg(l, P, Te(E, t, r, P, e, a));
  }), l;
}
var mh = Te, Eh = D, Ah = k, Oh = "[object Symbol]";
function Ch(e) {
  return typeof e == "symbol" || Ah(e) && Eh(e) == Oh;
}
var $t = Ch, wh = U, Nh = $t, Ph = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Sh = /^\w*$/;
function xh(e, t) {
  if (wh(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Nh(e) ? !0 : Sh.test(e) || !Ph.test(e) || t != null && e in Object(t);
}
var jh = xh, Mn = ut, Ih = "Expected a function";
function _t(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Ih);
  var r = function() {
    var n = arguments, s = t ? t.apply(this, n) : n[0], a = r.cache;
    if (a.has(s))
      return a.get(s);
    var l = e.apply(this, n);
    return r.cache = a.set(s, l) || a, l;
  };
  return r.cache = new (_t.Cache || Mn)(), r;
}
_t.Cache = Mn;
var Rh = _t, Fh = Rh, Lh = 500;
function Mh(e) {
  var t = Fh(e, function(n) {
    return r.size === Lh && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Bh = Mh, Gh = Bh, Vh = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Uh = /\\(\\)?/g, kh = Gh(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Vh, function(r, n, s, a) {
    t.push(s ? a.replace(Uh, "$1") : n || r);
  }), t;
}), Kh = kh, Br = Q, Xh = Nn, Wh = U, Yh = $t, qh = 1 / 0, Gr = Br ? Br.prototype : void 0, Vr = Gr ? Gr.toString : void 0;
function Bn(e) {
  if (typeof e == "string")
    return e;
  if (Wh(e))
    return Xh(e, Bn) + "";
  if (Yh(e))
    return Vr ? Vr.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -qh ? "-0" : t;
}
var Hh = Bn, zh = Hh;
function Jh(e) {
  return e == null ? "" : zh(e);
}
var Zh = Jh, Qh = U, Dh = jh, ev = Kh, tv = Zh;
function rv(e, t) {
  return Qh(e) ? e : Dh(e, t) ? [e] : ev(tv(e));
}
var Tt = rv;
function nv(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var sv = nv, av = $t, iv = 1 / 0;
function ov(e) {
  if (typeof e == "string" || av(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -iv ? "-0" : t;
}
var Gn = ov, uv = Tt, lv = Gn;
function cv(e, t) {
  t = uv(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[lv(t[r++])];
  return r && r == n ? e : void 0;
}
var fv = cv;
function dv(e, t, r) {
  var n = -1, s = e.length;
  t < 0 && (t = -t > s ? 0 : s + t), r = r > s ? s : r, r < 0 && (r += s), s = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var a = Array(s); ++n < s; )
    a[n] = e[n + t];
  return a;
}
var pv = dv, gv = fv, hv = pv;
function vv(e, t) {
  return t.length < 2 ? e : gv(e, hv(t, 0, -1));
}
var bv = vv, yv = Tt, $v = sv, _v = bv, Tv = Gn;
function mv(e, t) {
  return t = yv(t, e), e = _v(e, t), e == null || delete e[Tv($v(t))];
}
var Ev = mv, Av = D, Ov = bt, Cv = k, wv = "[object Object]", Nv = Function.prototype, Pv = Object.prototype, Vn = Nv.toString, Sv = Pv.hasOwnProperty, xv = Vn.call(Object);
function jv(e) {
  if (!Cv(e) || Av(e) != wv)
    return !1;
  var t = Ov(e);
  if (t === null)
    return !0;
  var r = Sv.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Vn.call(r) == xv;
}
var Iv = jv, Rv = Iv;
function Fv(e) {
  return Rv(e) ? void 0 : e;
}
var Lv = Fv, Ur = Q, Mv = vn, Bv = U, kr = Ur ? Ur.isConcatSpreadable : void 0;
function Gv(e) {
  return Bv(e) || Mv(e) || !!(kr && e && e[kr]);
}
var Vv = Gv, Uv = lt, kv = Vv;
function Un(e, t, r, n, s) {
  var a = -1, l = e.length;
  for (r || (r = kv), s || (s = []); ++a < l; ) {
    var u = e[a];
    t > 0 && r(u) ? t > 1 ? Un(u, t - 1, r, n, s) : Uv(s, u) : n || (s[s.length] = u);
  }
  return s;
}
var Kv = Un, Xv = Kv;
function Wv(e) {
  var t = e == null ? 0 : e.length;
  return t ? Xv(e, 1) : [];
}
var Yv = Wv;
function qv(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var Hv = qv, zv = Hv, Kr = Math.max;
function Jv(e, t, r) {
  return t = Kr(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, s = -1, a = Kr(n.length - t, 0), l = Array(a); ++s < a; )
      l[s] = n[t + s];
    s = -1;
    for (var u = Array(t + 1); ++s < t; )
      u[s] = n[s];
    return u[t] = r(l), zv(e, this, u);
  };
}
var Zv = Jv;
function Qv(e) {
  return function() {
    return e;
  };
}
var Dv = Qv;
function eb(e) {
  return e;
}
var tb = eb, rb = Dv, Xr = Pn, nb = tb, sb = Xr ? function(e, t) {
  return Xr(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: rb(t),
    writable: !0
  });
} : nb, ab = sb, ib = 800, ob = 16, ub = Date.now;
function lb(e) {
  var t = 0, r = 0;
  return function() {
    var n = ub(), s = ob - (n - r);
    if (r = n, s > 0) {
      if (++t >= ib)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var cb = lb, fb = ab, db = cb, pb = db(fb), gb = pb, hb = Yv, vb = Zv, bb = gb;
function yb(e) {
  return bb(vb(e, void 0, hb), e + "");
}
var $b = yb, _b = Nn, Tb = mh, mb = Ev, Eb = Tt, Ab = de, Ob = Lv, Cb = $b, wb = In, Nb = 1, Pb = 2, Sb = 4, xb = Cb(function(e, t) {
  var r = {};
  if (e == null)
    return r;
  var n = !1;
  t = _b(t, function(a) {
    return a = Eb(a, e), n || (n = a.length > 1), a;
  }), Ab(e, wb(e), r), n && (r = Tb(r, Nb | Pb | Sb, Ob));
  for (var s = t.length; s--; )
    mb(r, t[s]);
  return r;
}), jb = xb;
const Ib = /* @__PURE__ */ et(jb);
function Rb(e, t) {
  return new Array(t * e + 1).join(" ");
}
function kn(e) {
  return typeof e == "string" && e.includes(`
`);
}
function Fb(e) {
  return typeof e == "string" ? !1 : e.length === 1 && Ee in e[0] && !kn(e[0][Ee]);
}
function Lb(e) {
  switch (e) {
    case Ee:
    case rt:
    case tt:
      return e;
    default:
      return e.startsWith("?") ? zr : Es;
  }
}
function Mb(e) {
  const t = e[zt], r = Ib(e, zt), [[n, s]] = Object.entries(r), a = Lb(n);
  return { attributes: t, tagKey: n, subElements: s, type: a };
}
function Bb(e) {
  return e ? Object.keys(e).length > 0 : !1;
}
function Gb(e) {
  const { indentation: t, tagKey: r, attributes: n, children: s, isInline: a, hasChildren: l, level: u } = e, { collapsed: o, buttonProps: c } = Cn(u), { theme: f } = G();
  return /* @__PURE__ */ v.jsxs("div", { children: [
    /* @__PURE__ */ v.jsxs("span", { ...c, children: [
      /* @__PURE__ */ v.jsx("span", { children: t }),
      /* @__PURE__ */ v.jsx(On, { collapsed: o }),
      /* @__PURE__ */ v.jsx("span", { style: { color: f.separatorColor }, children: "<" }),
      /* @__PURE__ */ v.jsx("span", { style: { color: f.tagColor }, children: `${r}` }),
      !o && /* @__PURE__ */ v.jsx(wn, { attributes: n }),
      o && Bb(n) && " ...",
      /* @__PURE__ */ v.jsx("span", { style: { color: f.separatorColor }, children: l ? ">" : " />" })
    ] }),
    l && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      !o && s,
      o && "...",
      /* @__PURE__ */ v.jsx("span", { style: { color: f.separatorColor }, children: `${a || o ? "" : t}</` }),
      /* @__PURE__ */ v.jsx("span", { style: { color: f.tagColor }, children: `${r}` }),
      /* @__PURE__ */ v.jsx("span", { style: { color: f.separatorColor }, children: ">" })
    ] })
  ] });
}
function Vb(e) {
  const { hasSiblings: t, text: r, indentation: n, isText: s } = e, { theme: a } = G(), l = s ? { color: a.textColor } : void 0;
  return kn(r) || t ? /* @__PURE__ */ v.jsx("div", { style: l, children: r.split(`
`).filter((u) => !!u.trim()).map((u, o) => /* @__PURE__ */ v.jsx("div", { children: `${n}${u.trim()}` }, `${o}`)) }) : /* @__PURE__ */ v.jsx("span", { style: l, children: r });
}
function me(e) {
  const { elements: t, level: r = 0, isText: n = !0 } = e, { indentSize: s } = G();
  return !Array.isArray(t) || t.length === 0 ? null : /* @__PURE__ */ v.jsx(v.Fragment, { children: t.map((a, l) => {
    const { tagKey: u, attributes: o, subElements: c, type: f } = Mb(a), p = t.length > 1, h = Rb(s, r), $ = `${r}-${l}`, y = Fb(c);
    switch (f) {
      case Ee:
        return /* @__PURE__ */ v.jsx(
          Vb,
          {
            text: c,
            indentation: h,
            hasSiblings: p,
            isText: n
          },
          $
        );
      case tt:
        return /* @__PURE__ */ v.jsx(ud, { isInline: y, indentation: h, level: r, children: /* @__PURE__ */ v.jsx(me, { elements: c, level: r + 1, isText: !1 }) }, $);
      case rt:
        return /* @__PURE__ */ v.jsx(sd, { indentation: h, isInline: y, children: /* @__PURE__ */ v.jsx(me, { elements: c, level: r + 1, isText: !1 }) }, $);
      case zr:
        return /* @__PURE__ */ v.jsx(
          ld,
          {
            indentation: h,
            tagKey: u,
            attributes: o
          },
          $
        );
      default:
        return /* @__PURE__ */ v.jsx(
          Gb,
          {
            indentation: h,
            tagKey: u,
            attributes: o,
            isInline: y,
            hasChildren: c.length > 0,
            level: r,
            children: /* @__PURE__ */ v.jsx(me, { elements: c, level: r + 1 })
          },
          $
        );
    }
  }) });
}
function Ub() {
  return /* @__PURE__ */ v.jsx("div", { children: "Invalid XML!" });
}
function Wb(e) {
  const {
    theme: t,
    xml: r,
    collapsible: n = !1,
    indentSize: s = 2,
    invalidXml: a,
    initalCollapsedDepth: l,
    initialCollapsedDepth: u
  } = e, [o, c] = qr(() => ({ ...Ye, ...t })), { json: f, valid: p } = Ka(r), h = Yr(
    () => ({
      theme: o,
      collapsible: n,
      indentSize: s,
      initialCollapsedDepth: u ?? l
    }),
    [o, n, s, l, u]
  );
  return Hr(() => {
    c(($) => {
      const y = { ...Ye, ...t };
      return nd(y, $) ? $ : y;
    });
  }, [t]), p ? /* @__PURE__ */ v.jsx(Jr.Provider, { value: h, children: /* @__PURE__ */ v.jsx(
    "div",
    {
      className: "rxv-container",
      style: { whiteSpace: "pre-wrap", fontFamily: o.fontFamily, overflowWrap: "break-word" },
      children: /* @__PURE__ */ v.jsx(me, { elements: f })
    }
  ) }) : a || /* @__PURE__ */ v.jsx(Ub, {});
}
export {
  Wb as default
};
//# sourceMappingURL=index.es.js.map
